import {
  WINGS_CUP_LIVE,
  type WingsCupCountry,
  type WingsCupLang,
  type WingsCupTrackedUnit,
} from "@/features/WingsCup/wingsCupConfig";

import { mixpanelTrack } from "./mixpanelTrack";

/*
  Red Bull Wings Cup Open campaign. The partner report is users reached and
  clicks per market and per unit, so every event carries unit and country.
  `live` is false until launch, so test traffic can be filtered out.
*/
const CAMPAIGN = "Red Bull Wings Cup Open";

// Each unit reports the section (and subsection) its page already uses.
const PLACEMENT: Record<
  WingsCupTrackedUnit,
  { section: string; subsection?: string }
> = {
  sbc: { section: "SBC", subsection: "Overview" },
  gallery: { section: "Gallery", subsection: "List" },
  players: { section: "Players", subsection: "Overview" },
  "evo-players": { section: "Evolutions", subsection: "Players" },
  "evo-builder": { section: "Evolutions", subsection: "Builder" },
  navigation: { section: "Nav Bar" },
  "navigation-card": { section: "Nav Bar" },
  "navigation-link": { section: "Nav Bar" },
};

type WingsCupEventProps = {
  unit: WingsCupTrackedUnit;
  country: WingsCupCountry;
  lang: WingsCupLang;
};

const eventProps = ({ unit, country, lang }: WingsCupEventProps) => ({
  ...PLACEMENT[unit],
  campaign: CAMPAIGN,
  unit,
  country,
  lang,
  live: WINGS_CUP_LIVE,
});

/** Once per unit per page view, when at least half of it is on screen. */
export const trackWingsCupImpression = (props: WingsCupEventProps) =>
  mixpanelTrack("Wings Cup Impression", eventProps(props));

/** A click on the CTA or the menu link. */
export const trackWingsCupClick = (props: WingsCupEventProps) =>
  mixpanelTrack("banner_click", eventProps(props));
